import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg, tokenStore } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullScreenLoader } from "@/components/FullScreenLoader";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        const { session_token, ...user } = data;
        if (session_token) tokenStore.set(session_token);
        setUser(user);
        navigate("/projects", { replace: true });
      })
      .catch((e) => navigate("/login", { replace: true, state: { authError: errMsg(e, "Sign-in failed. Please try again.") } }));
  }, [location.hash, navigate, setUser]);

  return <FullScreenLoader label="Signing you in" />;
}
